import { type FunctionComponent, type PropsWithChildren } from 'react';

export const PopoverLayover: FunctionComponent<PropsWithChildren> = ({
  children,
}) => <>{children}</>;

PopoverLayover.displayName = 'PopoverLayover';
